import { apiRequest } from './api'

// Areas API service
export const areasService = {
  // Get all areas
  getAll: async (params = {}) => {
    const queryParams = {}

    // Convert page/page_size to skip/limit
    if (params.page && params.page_size) {
      queryParams.skip = (params.page - 1) * params.page_size
      queryParams.limit = params.page_size
    } else if (params.page_size) {
      queryParams.limit = params.page_size
    }

    if (params.brand_id) queryParams.brand_id = params.brand_id
    if (params.manager_id) queryParams.manager_id = params.manager_id
    if (params.is_active !== undefined) queryParams.is_active = params.is_active
    if (params.search) queryParams.search = params.search

    const response = await apiRequest.get('/areas/', { params: queryParams })
    return response.data
  },

  // Get area by ID
  getById: async (id) => {
    const response = await apiRequest.get(`/areas/${id}`)
    return response.data
  },

  // Create new area
  create: async (areaData) => {
    const response = await apiRequest.post('/areas/', areaData)
    return response.data
  },

  // Update area
  update: async (id, areaData) => {
    const response = await apiRequest.put(`/areas/${id}`, areaData)
    return response.data
  },

  // Delete area
  delete: async (id) => {
    const response = await apiRequest.delete(`/areas/${id}`)
    return response.data
  },

  // Get users in an area
  getAreaUsers: async (areaId, params = {}) => {
    const queryParams = {}
    
    if (params.page && params.page_size) {
      queryParams.skip = (params.page - 1) * params.page_size
      queryParams.limit = params.page_size
    }

    const response = await apiRequest.get(`/areas/${areaId}/users`, { params: queryParams })
    return response.data
  },

  // Assign users to area
  assignUsers: async (areaId, userIds) => {
    const response = await apiRequest.post(`/areas/${areaId}/users`, {
      user_ids: userIds,
      area_id: areaId
    })
    return response.data
  },

  // Remove user from area
  removeUser: async (areaId, userId) => {
    const response = await apiRequest.delete(`/areas/${areaId}/users/${userId}`)
    return response.data
  }
}

// User Areas API service
export const userAreasService = {
  // Get all user-area assignments
  getAll: async (params = {}) => {
    const queryParams = {}

    if (params.page && params.page_size) {
      queryParams.skip = (params.page - 1) * params.page_size
      queryParams.limit = params.page_size
    }

    if (params.user_id) queryParams.user_id = params.user_id
    if (params.area_id) queryParams.area_id = params.area_id

    const response = await apiRequest.get('/user-areas/', { params: queryParams })
    return response.data
  },

  // Get areas for a specific user
  getUserAreas: async (userId, params = {}) => {
    const queryParams = {}
    
    if (params.page && params.page_size) {
      queryParams.skip = (params.page - 1) * params.page_size
      queryParams.limit = params.page_size
    }

    const response = await apiRequest.get(`/user-areas/users/${userId}/areas`, { params: queryParams })
    return response.data
  },

  // Assign user to area
  assignUserToArea: async (userId, areaId) => {
    const response = await apiRequest.post(`/user-areas/users/${userId}/areas`, {
      user_id: userId,
      area_id: areaId
    })
    return response.data
  },

  // Remove user from area
  removeUserFromArea: async (userId, areaId) => {
    const response = await apiRequest.delete(`/user-areas/users/${userId}/areas/${areaId}`)
    return response.data
  }
}
